"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const WCAG_1 = tslib_1.__importStar(require("./WCAG"));
class TabbedPanelUtil {
    static addSROnlyHeader(tabbedPanel) {
        const header = this.createSROnlyHeader(tabbedPanel);
        tabbedPanel.element.prepend(header);
    }
    static createSROnlyHeader(tabbedPanel) {
        return WCAG_1.default.createSROnlyHeader({
            headerLevel: WCAG_1.HeaderLevel.H1,
            textContent: `Sideindhold: ${tabbedPanel.getTitle()}`
        });
    }
}
exports.default = TabbedPanelUtil;
//# sourceMappingURL=TabbedPanelUtil.js.map